import { ConversationRouterLayout } from "@spa/app/layouts/ConversationRouterLayout";
import { PodRouterLayout } from "@spa/app/layouts/PodRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";
import { Navigate, useLocation, useParams } from "react-router-dom";

const ManagePodsPage = withSuspense(
  () => import("@dust-tt/front/components/pages/pod/ManagePodsPage"),
  "ManagePodsPage"
);

const PodConversationPage = withSuspense(
  () => import("@dust-tt/front/components/pages/pod/PodConversationPage"),
  "PodConversationPage"
);

const PodPage = withSuspense(
  () => import("@dust-tt/front/components/pages/pod/PodPage"),
  "PodPage"
);

// Redirect legacy /conversation/space/:spaceId URLs
// to the new /pods/:podId path.
function LegacySpaceToPodRedirect() {
  const { spaceId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={`../pods/${spaceId}${location.search}${location.hash}`}
      replace
    />
  );
}

// A pod is called a Project everywhere a user reads it, so the URL a user might
// type answers too. The route itself stays /pods.
function ProjectsIndexRedirect() {
  const location = useLocation();
  return <Navigate to={`../pods${location.search}${location.hash}`} replace />;
}

function ProjectToPodRedirect() {
  const { projectId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={`../pods/${projectId}${location.search}${location.hash}`}
      replace
    />
  );
}

export const podsRoutes: RouteObject[] = [
  {
    path: "pods",
    element: <ManagePodsPage />,
  },
  {
    path: "pods/:podId",
    element: <PodRouterLayout />,
    children: [
      {
        index: true,
        element: <PodPage />,
      },
    ],
  },
  {
    path: "pods/:podId/conversation",
    element: <ConversationRouterLayout />,
    children: [{ path: ":cId", element: <PodConversationPage /> }],
  },
  {
    path: "conversation/space/:spaceId",
    element: <LegacySpaceToPodRedirect />,
  },
  {
    path: "projects",
    element: <ProjectsIndexRedirect />,
  },
  {
    path: "projects/:projectId",
    element: <ProjectToPodRedirect />,
  },
];
